import { useState } from "react";
import { SessionData } from "./types";
import { createSession } from "./api";

interface Props {
  data: SessionData;
  update: (patch: Partial<SessionData>) => void;
  onNext: () => void;
}

export function ContactInfoStep({ data, update, onNext }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const valid =
    data.name.trim() !== "" && data.phone.trim() !== "" && data.email.trim() !== "";

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!valid || loading) return;

    // If session was already created (user navigated back), just advance.
    if (data.sessionId != null) {
      onNext();
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const result = await createSession({
        name: data.name,
        phone: data.phone,
        email: data.email,
      });
      update({ sessionId: result.id, sessionToken: result.token });
      onNext();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="wizard-step" onSubmit={submit}>
      <header className="wizard-step-header">
        <h2>Let's get started</h2>
        <p>We'll use this to coordinate your notarization.</p>
      </header>

      <label className="wizard-field">
        <span className="wizard-label">Legal Name (matches what is on your ID and documents)</span>
        <input
          type="text"
          autoComplete="name"
          placeholder="Jane Smith"
          value={data.name}
          onChange={(e) => update({ name: e.target.value })}
        />
      </label>

      <label className="wizard-field">
        <span className="wizard-label">Phone Number</span>
        <input
          type="tel"
          autoComplete="tel"
          placeholder="(555) 000-0000"
          value={data.phone}
          onChange={(e) => update({ phone: e.target.value })}
        />
      </label>

      <label className="wizard-field">
        <span className="wizard-label">Email Address</span>
        <input
          type="email"
          autoComplete="email"
          placeholder="jane@example.com"
          value={data.email}
          onChange={(e) => update({ email: e.target.value })}
        />
      </label>

      {error && <div className="wizard-error">{error}</div>}

      <button
        type="submit"
        className="wizard-button-primary"
        disabled={!valid || loading}
      >
        {loading ? "Saving…" : "Continue"}
      </button>
    </form>
  );
}
